export default __webpack_public_path__ + "media/images/theme/m_logo_light-85ca1a42172f51419369f958ad646009.png";